var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from '@decahedron/entity';
import { Question } from './Question';
import { Option } from './Option';
var SUBTYPES = {
    multiple: 'multiple',
};
var MultiChoiceQuestion = /** @class */ (function (_super) {
    __extends(MultiChoiceQuestion, _super);
    function MultiChoiceQuestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = [];
        return _this;
    }
    Object.defineProperty(MultiChoiceQuestion, "subtypes", {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: function () {
            return SUBTYPES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiChoiceQuestion.prototype, "allowsMultipleOptions", {
        // / Test if the current entity allows multiple options in answers
        get: function () {
            return this.subtype === SUBTYPES.multiple;
        },
        enumerable: false,
        configurable: true
    });
    // / Set allowing multiple options for answers
    MultiChoiceQuestion.prototype.setMultipleAllowed = function (allowMultiple) {
        this.subtype = (allowMultiple) ? SUBTYPES.multiple : null;
    };
    __decorate([
        Type(Option),
        __metadata("design:type", Array)
    ], MultiChoiceQuestion.prototype, "options", void 0);
    return MultiChoiceQuestion;
}(Question));
export { MultiChoiceQuestion };
